// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.line-type-indicator {
  display: inline-block;
  vertical-align: middle;
  margin-left: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Elements/lineTypeIndicator.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,sBAAA;EACA,mBAAA;AACF","sourcesContent":[".line-type-indicator {\n  display: inline-block;\n  vertical-align: middle;\n  margin-left: .5rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
